const NICE_MULTIPLIERS = [1, 2, 2.5, 5, 7.5, 10]
const DEFAULT_TICKS = [0, 500, 1000, 1500]

// Rounds a raw step size to a "nice" number like 1, 2, 5, or 10 * 10^n. (e.g. 66.6 -> 100, 2400 -> 5000)
const getRoundedStep = (approxStep: number): number => {
  // The largest power of 10 less than or equal to approxStep. (e.g. 25 -> 10, 250 -> 100)
  const basePower = Math.pow(10, Math.floor(Math.log10(approxStep)))

  // Normalized value of the step relative to the base power. (e.g. 25 -> 2.5, 550 -> 5.5)
  const normalizedStep = approxStep / basePower

  // Pick the nearest "nice" multiplier (1, 2, 5, 10). (e.g. 2.5 -> 5, 6.66 -> 10)
  const roundedMultiplier = NICE_MULTIPLIERS.find((multiplier) => normalizedStep <= multiplier) ?? 10

  return roundedMultiplier * basePower
}

// Generates graph ticks based on domain value and intervals
export const getGraphTicks = (graphDomain: number[], intervals = 3): number[] => {
  const maxValue = graphDomain[1]

  // Ensures intervals > 0
  const safeIntervals = Math.max(intervals, 1)

  // Fallback values when domain is too small or invalid
  if (maxValue <= 0 || maxValue < safeIntervals) {
    return DEFAULT_TICKS
  }

  const roughStep = maxValue / intervals

  // Round the rough step to a "nice" value. (e.g. roughStep = 833.33 -> step = 1000)
  const step = getRoundedStep(roughStep)

  // Generate an array of tick values from 0 up to maxValue
  const ticks = Array.from({ length: intervals + 1 }, (_, index) => index * step)

  return ticks
}
